import { ReduxUtils, Consts } from '../dependencies';

export const routePaths = ReduxUtils.strictObjectAccess({
    LISTS: '/lists',
    LISTS_SUPPLIERS: '/lists/suppliers',
    LISTS_TAGS: '/lists/tags',
    LISTS_EXPENSES_RECURRING: Consts.routes.LISTS_EXPENSES_RECURRING,
});
